import { render, staticRenderFns } from "./TableCellTypeEmail.vue?vue&type=template&id=45a43142&scoped=true"
import script from "./TableCellTypeEmail.vue?vue&type=script&lang=js"
export * from "./TableCellTypeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a43142",
  null
  
)

export default component.exports